import React from "react";
import { TopicCardView } from "./view";
import { styles } from "./styles";

export class TopicCard extends React.Component {
  render() {
    return <TopicCardView {...this.props} styles={styles} />;
  }
}
